import { render, staticRenderFns } from "./MyPlanJoinedGroup.vue?vue&type=template&id=4b540ecd&scoped=true"
import script from "./MyPlanJoinedGroup.vue?vue&type=script&lang=js"
export * from "./MyPlanJoinedGroup.vue?vue&type=script&lang=js"
import style0 from "./MyPlanJoinedGroup.vue?vue&type=style&index=0&id=4b540ecd&prod&lang=scss&scoped=true"
import style1 from "./MyPlanJoinedGroup.vue?vue&type=style&index=1&id=4b540ecd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b540ecd",
  null
  
)

export default component.exports